import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import useOrganizationSettings from '@app/src/hooks/useOrganizationSettings'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import type { Unit } from '@app/src/types/resourceExplorer'
import { TWELVE_HOURS_MS } from '@app/src/wf-constants'

const UNIT_CACHE_TIME = TWELVE_HOURS_MS

interface UseOrganizationCurrencyProps {
  enabled?: boolean
  currencyUnitId?: number
}

const useOrganizationCurrency = ({ enabled = true, currencyUnitId }: UseOrganizationCurrencyProps = {}): {
  organizationCurrency?: Unit
  isLoading: boolean
} => {
  const { settings, isLoading: isLoadingOrganizationSettings } = useOrganizationSettings({
    enabled: enabled && currencyUnitId === undefined,
  })
  const resolvedCurrencyUnitId = currencyUnitId ?? settings?.currencyUnitId

  const { items: units, isLoading: isLoadingUnits } = useFetchCollectionWithPost<Unit>({
    key: FetchKey.Unit,
    endpoint: endpoints.units,
    payload: {
      filter: [
        {
          name: 'id',
          filters: [{ value: resolvedCurrencyUnitId, operator: Operators.EqualTo }],
        },
      ],
      include: [],
      pagination: { itemsPerPage: 1, pageNumber: 1 },
    },
    options: {
      enabled: enabled && Boolean(resolvedCurrencyUnitId),
      refetchOnMount: false,
      gcTime: UNIT_CACHE_TIME,
      staleTime: UNIT_CACHE_TIME,
    },
  })

  return {
    organizationCurrency: units?.[0],
    isLoading: isLoadingOrganizationSettings || isLoadingUnits,
  }
}

export default useOrganizationCurrency
